export default __webpack_public_path__ + "static/media/how-do-clubs-work-header.1bdfaa27.jpg";